import { createWebAuthClient } from '@church/api-client'
import { apiBaseUrl } from './api.ts'

/** better-auth client — sign-in/up, org management. Same-origin, cookie-backed. */
export const authClient = createWebAuthClient(apiBaseUrl)
